import React from 'react';
import { Helmet } from 'react-helmet-async';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import ImportTool from '../Settings/Import/ImportTool';

/** Activos > Importar gastos: the Excel importer, for now limited to bills (server side too). */
export default function ImportBills() {
	const { t } = useLabels();
	const title = t('import.billsPageTitle');
	return (
		<EntityList>
			<Helmet>
				<title>{title}</title>
			</Helmet>
			<PageHead
				breadcrumb={[{ label: t('entity.asset.plural'), to: '/AdminScreen/assets' }, { label: title }]}
				title={title}
				subtitle={t('import.billsPageDescription')}
			/>
			<ImportTool />
		</EntityList>
	);
}
